import { useContext } from "react"
import { AppContext } from "../App"
import { MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import logo from '../assets/logo.png';
import logo_worded_only from '../assets/logo_worded_only.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({
      item,
    })
  }

  return (
    <div
      className="TopBar"
    >
      <div className="body">
        <div
          className="container d-flex justify-content-between"
          style={{
            height: "100%",
          }}
        >
          <div 
            className="align-self-center d-flex"
            style={{
              height: "100%",
              flexShrink: 1,

            }}
          >
            <MdMenu
              className="align-self-center mMobileOnly"
              size={32}
              style={{
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "0px"
              }}
              onClick={appContext.openSideBar}
            />
            <img
              src={logo_worded_only}
              style={{
                height: "25px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center"
              onClick={() => {
                appContext.navTo({
                  item: '',
                })
              }}
            />
          </div>

          <div
            className="DesktopMenu align-self-center mNoMargin mNoPadding"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
              onClick={() => goTo("")}
            >
              Home
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("hotels")}
            >
              Hotels
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("about_us")}
            >
              About Us
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("contact_us")}
            >
              Contact Us
            </div>

            <div
              className="mMenuItem"
              onClick={() => {
                window.open("https://play.google.com/store/apps/details?id=com.werenium.avan", "_blank");
              }}
            >
              For Android
            </div>

            <div
              className="mMenuItem"
              onClick={() => {
                window.open("https://avanhotels.com/app", "_blank");
              }}
            >
              For iOS
            </div>

            <div
              className="mMenuItem"
              onClick={() => {
                window.open("https://avanhotels.com/app", "_blank");
              }}
            >
              <button
                className="btn btn-secondary font-bold"
                style={{
                  fontSize: "14px"
                }}
              >
                GET STARTED
              </button>
            </div>

          </div>

          <div
            className="align-self-center mNoMargin mNoPadding mMobileOnly"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
              onClick={() => goTo("")}
            >
              <button
                className="btn btn-secondary font-bold"
                style={{
                  fontSize: "14px"
                }}
                onClick={() => {
                  window.open("https://avanhotels.com/app", "_blank");
                }}
              >
                GET STARTED
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}